import { useState } from "react";
var useLocalStorage = function (key, initialValue) {
    // Utiliser useState pour que la logique ne soit exécutée qu'une seule fois
    var _a = useState(function () {
        if (typeof window === "undefined") {
            return initialValue;
        }
        try {
            // recupère la valeur du clé depuis local storage
            var item = window.localStorage.getItem(key);
            // Analyser le json stocké ou si aucun  valeur trouvé on renvoie initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.log(error);
            // Si erreur on renvoie également la valeur initiale
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    // Enregistrer la nouvelle valeur dans localStorage
    var setValue = function (value) {
        try {
            // Autoriser la valeur à être une fonction afin que nous ayons la même API que useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Enregistrer dans le state
            setStoredValue(valueToStore);
            // Enregistrer dans le stockage local
            if (typeof window !== "undefined") {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            console.log(error);
        }
    };
    return [storedValue, setValue];
};
export default useLocalStorage;
